import type { Settings as BarChartSettings } from "./bar-chart/settings";
import type { Settings as GaugeChartSettings } from "./gauge-chart/settings";
import type { Settings as StatChartSettings } from "./stat-chart/settings";
import type { Settings as TimeSeriesChartSettings } from "./time-series-chart/settings";

type Spec =
	| { kind: "TimeSeriesChart"; settings?: TimeSeriesChartSettings }
	| { kind: "BarChart"; settings?: BarChartSettings }
	| { kind: "GaugeChart"; settings?: GaugeChartSettings }
	| { kind: "StatChart"; settings?: StatChartSettings };

type Kind = Spec["kind"];

const ALL_KINDS = ["TimeSeriesChart", "BarChart", "GaugeChart", "StatChart"] as const satisfies ReadonlyArray<Kind>;
const [DEFAULT_KIND] = ALL_KINDS;

export { DEFAULT_KIND, ALL_KINDS };
export type { Spec, Kind };
